import { Stack, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import show from '../../../api/auth/locations/show';
import PageLoading from '../../../components/layout/PageLoading';
import index from '../../../api/auth/locations/reservations';
import ExpandableOrderCard from '../../../components/displays/orders/ExpandableOrderCard';
import LocationForm from '../../../components/form/locations/LocationForm';

export default function Location() {
  const [ location, setLocation ] = useState();

  const [ reservations, setReservations ] = useState();

  const { id } = useParams();

  useEffect(() => {
    show(id, (response) => {
      setLocation(response);
    });
  }, []);

  useEffect(() => {
    index(id, (response) => {
      setReservations(response);
    });
  }, []);

  if(!location) return <PageLoading />;

  const inProgressReservations = reservations?.filter((reservation) => reservation.in_progress);
  const upcomingReservations = reservations?.filter((reservation) => reservation.in_future);
  const pastReservations = reservations?.filter((reservation) => reservation.in_past);

  return (
    <Stack>
      <Stack mb={4}>
        <LocationForm location={location} />
      </Stack>
      <Stack>
        {inProgressReservations?.length > 0 && <Stack>
          <Typography variant="h6" fontWeight="700">In progress reservations</Typography>
          {inProgressReservations.map((reservation) => (
            <ExpandableOrderCard key={`current-${reservation.id}`} order={reservation.order} />
          ))}
        </Stack>}
        {upcomingReservations?.length > 0 && <Stack>
          <Typography variant="h6" fontWeight="700">Upcoming reservations</Typography>
          {upcomingReservations.map((reservation) => (
            <ExpandableOrderCard key={`future-${reservation.id}`} order={reservation.order} />
          ))}
        </Stack>}
        {pastReservations?.length > 0 && <Stack>
          <Typography variant="h6" fontWeight="700">Past reservations</Typography>
          {pastReservations.map((reservation) => (
            <ExpandableOrderCard key={`future-${reservation.id}`} order={reservation.order} />
          ))}
        </Stack>}
      </Stack>
    </Stack>
  );
}